import React from 'react';
import SuperAdminLayout from '../../components/admin/SuperAdminLayout';
import SystemServicesManager from '../../components/admin/SystemServicesManager';

const SystemServicesPage: React.FC = () => {
  return (
    <SuperAdminLayout>
      <SystemServicesManager />
    </SuperAdminLayout>
  );
};

export default SystemServicesPage;